/**
 * @desc 导入msku映射
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: string, options?: any) {
  return updateResponse(
    http(URL + `/mskuMap/importMsku`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
